import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompareOfferPopupComponent } from './compare-offer-popup.component';
import { DialogModule } from 'primeng/dialog';
import { SidebarModule } from 'primeng/sidebar';



@NgModule({
  declarations: [CompareOfferPopupComponent],
  imports: [
    CommonModule,
    DialogModule,
    SidebarModule
  ],
  exports:[CompareOfferPopupComponent]
})
export class CompareOfferPopupModule { }
